<template>
    <div class="d-flex flex-row label-item">
        <template v-if="editing">
            <mini-input :value.sync="localValue" without-label type="input" class="flex-grow-1"></mini-input>
            <b-button-group class="ml-1">
                <b-button variant="light" @click="cancel">取消</b-button>
                <b-button variant="info" @click="toSave" :disabled="localValue===value">保存</b-button>
            </b-button-group>
        </template>
        <template v-else>
            <div class="m-tb-auto ml-2">
                {{ localValue }}
            </div>
            <b-button-group class="ml-auto">
                <b-button variant="light" @click="toEdit">
                    <i class="fa-solid fa-pen-to-square"></i>
                </b-button>
                <delete-button :additionText="value"
                               variant="light"
                               @btnClick="toDelete"></delete-button>
            </b-button-group>
        </template>
    </div>
</template>

<script>
import MiniInput from "@/components/common/inputs/MiniInput.vue";
import DeleteButton from "@/components/common/buttons/DeleteButton.vue";

export default {
    name: "CommonEDInput",
    components: {DeleteButton, MiniInput},
    props: {
        value: null
    },
    data() {
        return {
            localValue: null,
            editing: false,
        }
    },
    watch: {
        value() {
            this.localValue = this.value;
            this.editing = false;
        },
    },
    mounted() {
        this.localValue = this.value
    },
    methods: {
        cancel() {
            this.editing = false;
            this.localValue = this.value;
        },
        toEdit() {
            this.editing = true;
        },
        toSave() {
            this.$emit('save', this.localValue);
        },
        toDelete() {
            this.$emit('delete');
        },
    }
}
</script>

<style scoped>
.label-item {
    cursor: pointer;
}

.label-item:hover {
    background-color: #f1f4f6;
}
</style>
